import { connect } from 'react-redux';
import { RootState } from 'store/configureStore';
import DueDiligence from 'screens/Panel/screens/Firm/components/DueDiligence/DueDiligence';
import { DueDiligence as DueDiligenceType, DueDiligenceChecklist } from 'utils/api/types';
import reloadFirm from 'screens/Panel/screens/Firm/store/show/useCases/reloadFirm';
import { FirmTypes } from 'components/Profile/CmFirmProfile/types';
import { setDDTab } from 'screens/Panel/screens/Firm/store/show/actions';

export default connect(
  (state: RootState) => {
    return {
      firmId: state.firmShow.firm?.company.id || '',
      firmType: state.firmShow.firm?.company.firmType as FirmTypes,
      dueDiligence: state.firmShow.firm?.company.dueDiligence as DueDiligenceType,
      dueDiligenceChecklist: state.firmShow.firm?.company.dueDiligenceChecklist as DueDiligenceChecklist,
      activeTab: state.firmShow.dueDiligenceTab,
      user: state.auth.user,
    };
  },
  { reloadFirm, setActiveTab: setDDTab },
)(DueDiligence);
